import api from '../../utils/api';
import { alertError } from './alert';
import { getSupplierRetailersAll } from './api/suppliers';
import {
  STAT_CANCELLATION_RATE,
  STAT_AVG_TIME_TO_SHIP,
  STAT_SHIP_ON_TIME_RATE,
  STAT_GMV,
  STAT_AOV,
  STAT_IPT,
  STAT_BEST_SELLERS,
} from '../../constants/stats';

import { SUPPLIER_STATS_DATA, SUPPLIER_STATS_LOADING, SUPPLIER_STATS_RETAILERS } from '../constants/statsTypes';

export const setSupplierStatsData = (data) => ({ type: SUPPLIER_STATS_DATA, payload: data });
export const setSupplierStatsLoading = (value) => ({ type: SUPPLIER_STATS_LOADING, payload: value });
export const setStatsSupplierRetailers = (retailers) => ({ type: SUPPLIER_STATS_RETAILERS, payload: retailers });

export const getStats = (startDate, endDate, retailerId) => async (dispatch, getState) => {
  const state = getState();
  const { supplierId } = state.role;
  const keys = [
    STAT_CANCELLATION_RATE,
    STAT_BEST_SELLERS,
    STAT_AVG_TIME_TO_SHIP,
    STAT_SHIP_ON_TIME_RATE,
    STAT_GMV,
    STAT_AOV,
    STAT_IPT,
  ];

  dispatch(setSupplierStatsLoading(keys));

  const params = {
    keys,
    from: startDate.format(),
    to: endDate.format(),
  };

  if (retailerId) {
    params.retailerId = retailerId;
  }

  try {
    const response = await api.post(`/suppliers/${supplierId}/stats`, params);
    if (response.data) {
      dispatch(setSupplierStatsData(response.data));
    } else {
      dispatch(alertError(`Couldn't get stats for keys: ${keys.join(', ')}`));
    }

    dispatch(setSupplierStatsLoading(false));
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const getStatsSupplierRetailers = () => async (dispatch, getState) => {
  const state = getState();
  const { supplierId } = state.role;

  try {
    const retailersResponse = await getSupplierRetailersAll(supplierId);
    dispatch(setStatsSupplierRetailers(retailersResponse.data));
  } catch (error) {
    dispatch(alertError(error));
  }
};
